import { z } from 'zod';

/**
 * Notification categories. Each category gates the device push only — the
 * in-app history feed always receives the row, so muting a category never
 * hides account state from the user.
 */
export const NOTIFICATION_CATEGORIES = ['trade', 'risk', 'alert', 'challenge', 'wallet', 'announcement'] as const;
export const NotificationCategorySchema = z.enum(NOTIFICATION_CATEGORIES);
export type NotificationCategory = z.infer<typeof NotificationCategorySchema>;

/** Partial map — a missing key means the category is enabled (default ON). */
export const NotificationPrefsSchema = z.record(NotificationCategorySchema, z.boolean());
export type NotificationPrefs = z.infer<typeof NotificationPrefsSchema>;

export const NotificationSchema = z.object({
  /** bigserial serialized as string — also the pagination cursor. */
  id: z.string(),
  category: NotificationCategorySchema,
  /** Event kind, e.g. 'order_fill', 'challenge_passed', 'announcement'. */
  kind: z.string(),
  title: z.string(),
  body: z.string(),
  data: z.record(z.string(), z.unknown()),
  createdAt: z.number(), // epoch ms
  readAt: z.number().nullable(),
});
export type Notification = z.infer<typeof NotificationSchema>;
